<template>
  <div>
    <div class="top-bar">
      <span>
        <i class="left" @click="back()"></i>
      </span>
      <span class="heading_new">Statutory deduction override</span>
      <span class="spacer" />
    </div>
    <div class="main-container">
      <selected-employee-card :empName="emp.name" :empId="emp.code" :empMail="emp.email" />
      <div class="row margin-t-s">
        <div class="col-3">
          <txt
            label="Month"
            name="month"
            v-model="currentMonth"
            disabled="true"
            :autofocus="false"
          />
        </div>
      </div>
      <div class="margin-t-s">
        <ul class="table-header header">
          <li class="table-header-item">Components</li>
          <li class="table-header-item">Month</li>
          <li class="table-header-item">Amount Paid</li>
          <li class="table-header-item">Override Amount</li>
          <li class="table-header-item">Difference Amount</li>
        </ul>
        <div class="row-div" v-for="(item,index) in deductionData.tableData" :key="index">
          <ul class="table-row">
            <li class="table-row-item">{{item.component}}</li>
            <li class="table-row-item">{{item.months[0] ? item.months[0].month : "-"}}</li>
            <li class="table-row-item">{{item.months[0] ? item.months[0].amount : item.amount}}</li>
            <li class="table-row-item" v-if="item.months[0]">
              <txt
                type="number"
                :name="'overrideamount'+index+0"
                v-model="item.months[0].override_amount"
                @change="item.months[0].difference_amount = item.months[0].amount - item.months[0].override_amount;calculateTotal(index)"
              />
            </li>
            <li class="table-row-item" v-else>
              <txt
                type="number"
                :name="'overrideamount'+index+0"
                v-model="item.override_amount"
                @change="item.difference_amount = item.amount - item.override_amount;calculateTotal(index)"
              />
            </li>
            <li
              class="table-row-item"
            >{{item.months[0] ? item.months[0].difference_amount : item.difference_amount}}</li>
          </ul>
          <div v-if="item.months">
            <ul
              class="table-row"
              v-for="(component, idx) in item.months.slice(1, item.months.length)"
              :key="idx"
            >
              <li class="table-row-item"></li>
              <li class="table-row-item">{{component.month}}</li>
              <li class="table-row-item">{{component.amount}}</li>
              <li class="table-row-item">
                <txt
                  type="number"
                  :name="'overrideamount'+index+idx"
                  v-model="component.override_amount"
                  @change="component.difference_amount = component.amount - component.override_amount;calculateTotal(index)"
                />
              </li>
              <li class="table-row-item">{{component.difference_amount}}</li>
            </ul>
          </div>
        </div>
        <ul class="table-row total">
          <li class="table-row-item">Total</li>
          <li class="table-row-item">{{deductionData.month}}</li>
          <li class="table-row-item">Rs. {{deductionData.amount}}</li>
          <li class="table-row-item">Rs. {{deductionData.override_amount}}</li>
          <li class="table-row-item">Rs. {{deductionData.difference_amount}}</li>
        </ul>
      </div>
    </div>
    <pop-up-message
      v-if="showSuccessMsg"
      :message="`Statutory deduction override save succesfully.`"
      btnText="Back to Statutory Deduction Override"
      @back="back"
    ></pop-up-message>
    <bottom-action-container >
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="back" />
          <btn text="Save" type="primary" @click="submit" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import SelectedEmployeeCard from "@/components/dashboard/selectedEmployeeCard.vue";
export default {
  components: {
    SelectedEmployeeCard
  },
  data() {
    return {
      emp: {
        name: "",
        email: "",
        code: ""
      },
      showSuccessMsg: false,
      currentMonth: "October",
      effMonthOptions: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      deductionData: {
        tableData: [
          {
            component: "Basic",
            months: [
              {
                month: "April",
                amount: 120000,
                override_amount: null,
                difference_amount: 0
              },
              {
                month: "May",
                amount: 120000,
                override_amount: null,
                difference_amount: 0
              },
              {
                month: "June",
                amount: 120000,
                override_amount: null,
                difference_amount: 0
              }
            ],
            amount: "-",
            override_amount: "-",
            difference_amount: "-"
          },
          {
            component: "PF",
            months: [
              {
                month: "April",
                amount: 120000,
                override_amount: null,
                difference_amount: 0
              },
              {
                month: "May",
                amount: 120000,
                override_amount: null,
                difference_amount: 0
              },
              {
                month: "June",
                amount: 120000,
                override_amount: null,
                difference_amount: 0
              },
              {
                month: "July",
                amount: 120000,
                override_amount: null,
                difference_amount: 0
              },
              {
                month: "August",
                amount: 120000,
                override_amount: null,
                difference_amount: 0
              }
            ],
            amount: "-",
            override_amount: "-",
            difference_amount: "-"
          },
          {
            component: "LTA",
            months: [],
            amount: 120000,
            override_amount: null,
            difference_amount: 0
          }
        ],
        component: "Total",
        months: "",
        amount: 0,
        override_amount: null,
        difference_amount: null
      }
    };
  },
  computed: {},
  activated() {
    if (this.$route.query.emp) {
      //console.log(this.$route.query.emp);

      let obj = this.$route.query.emp;
      this.emp.name = obj.name;
      this.emp.code = obj.code;
      this.emp.email = obj.email_id;
    }
    let totalAmount = 0;
    this.deductionData.tableData.forEach(element => {
      if (element.months.length) {
        element.months.forEach(item => {
          totalAmount += item.amount;
        });
      } else {
        totalAmount += element.amount;
      }
    });
    this.deductionData.amount = totalAmount;
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    submit() {
      this.showSuccessMsg = true;
      //console.log(this.deductionData);
    },
    calculateTotal(index) {
      let totalOverRideAmount = 0;
      let totalDifferenceAmount = 0;
      this.deductionData.tableData.forEach(element => {
        if (element.months.length) {
          element.months.forEach(item => {
            totalOverRideAmount += item.override_amount;
            totalDifferenceAmount += item.difference_amount;
          });
        } else {
          totalOverRideAmount += element.override_amount;
          totalDifferenceAmount += element.difference_amount;
        }
      });

      this.deductionData.override_amount = totalOverRideAmount;
      this.deductionData.difference_amount = totalDifferenceAmount;
    }
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}
.heading_new {
  width: auto;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}
.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}
.rectangle {
  height: 50px;
  border-radius: 4px;
  background-color: #f9f9f9;
  padding: 15px 30px;
}

.upload-digitally-sig {
  font-family: Montserrat;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #646464;
}
.info-icon {
  border: 1px #646464 solid;
  border-radius: 100%;
  width: 20px;
  height: 20px;
  margin: 0 5px 0 0;
  display: inline-block;
  vertical-align: middle;
  font-size: 15px;
  color: #646464;
}
.noteText {
  font-size: 12px;
  color: #6e6e6e;
}

.header {
  background-color: #dedede;
}
.table-header {
  display: inline-flex;
  width: 100%;
  padding: 10px 0px;
  .table-header-item {
    padding: 5px 10px;
    width: 100%;
    color: #000000;
    opacity: 0.68;
    font-weight: 500;
  }
}
.row-div {
  &:nth-child(odd) {
    background-color: #fbfbfb;
  }
}
.table-row {
  display: inline-flex;
  width: 100%;
  padding: 10px 0px;

  .table-row-item {
    padding: 5px 10px;
    width: 100%;
    color: #000000;
    opacity: 0.68;
    font-weight: 500;
    a {
      color: blue;
      text-decoration: underline;
    }
  }
}
.total {
  .table-row-item {
    font-weight: 600;
  }
}
.d_heading {
  font-size: 14px;
  font-weight: 600;
  opacity: 0.68;
  color: #646464;
}
</style>
